import { render, staticRenderFns } from "./EnablingFarmersView.vue?vue&type=template&id=7ebdcd35&scoped=true&"
import script from "./EnablingFarmersView.vue?vue&type=script&lang=js&"
export * from "./EnablingFarmersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebdcd35",
  null
  
)

export default component.exports